import React, { useEffect, useState, memo } from 'react';
const setCookie = (name: string, value: string, days: number) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = '; expires=' + date.toUTCString();
  document.cookie = name + '=' + value + expires + '; path=/';
};
const getCookie = (name: string) => {
  if (typeof document === 'undefined') return null;
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
export const CopiesCounter = memo(function CopiesCounter() {
  const [copiesLeft, setCopiesLeft] = useState(() => {
    if (typeof document !== 'undefined') {
      const storedCount = getCookie('copiesLeft_silencio');
      return storedCount ? parseInt(storedCount) : 15;
    }
    return 15;
  });
  useEffect(() => {
    if (!getCookie('copiesLeft_silencio')) {
      setCookie('copiesLeft_silencio', '15', 1);
    }
    let intervalId: NodeJS.Timeout;
    const timeoutId = setTimeout(() => {
      intervalId = setInterval(() => {
        setCopiesLeft(prevCount => {
          const newCount = prevCount > 2 ? prevCount - 1 : 2;
          setCookie('copiesLeft_silencio', newCount.toString(), 1);
          return newCount;
        });
      }, 8000);
    }, 3000);
    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, []);
  return <div className="bg-[#1a1f3a] border-b border-[#2a3150] py-2 flex justify-center" data-id="element-17">
      <div className="bg-[#d4a853]/10 border border-[#d4a853]/30 text-[#d4a853] font-medium px-4 py-1.5 rounded-full text-sm animate-pulse-soft flex items-center gap-2" data-id="element-18">
        <span className="relative flex h-2.5 w-2.5" data-id="element-19">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#d4a853] opacity-75" data-id="element-20"></span>
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#d4a853]" data-id="element-21"></span>
        </span>
        Solo quedan {copiesLeft} copias disponibles
      </div>
    </div>;
});